<template>
    <div class="container-list">
        <div class="common-page common-head">
            <div class="common-page common-head-title">
                <i class="icon-tr--detailed" style="padding-right: 5px"></i>
                设备信息管理
            </div>
            <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
        </div>
        <div class="common-page common-body">
            <div class="common-page common-tool-bar">
                <div class="btn" v-hasPermi="['basic:device:query']" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
                <router-link class="btn ml20" v-hasPermi="['basic:device:add']" to="/device/device-add"><i class="icon-tr-newly-added "  ></i>新增</router-link>
            </div>
            <div class="">
                <el-table :data="list" class="">
                    <el-table-column
                            prop="device_code"
                            label="设备编号"
                            align="center">
                    </el-table-column>

                    <el-table-column
                            prop="model"
                            label="设备型号"
                            align="center">
                    </el-table-column>
                  
                    <el-table-column
                            prop="NAME"
                            align="center"
                            label="设备名称">
                    </el-table-column>
                     <el-table-column
                            prop="c_name"
                            align="center"
                            label="单位名称">
                    </el-table-column>
                    <el-table-column
                            prop="MODE"
                            align="center"
                            label="通讯模式">
                    </el-table-column>
                    <el-table-column
                            prop="hardware_version"
                            align="center"
                            label="软件版本">
                    </el-table-column>
                    <el-table-column
                            prop="hardware_version"
                            align="center"
                            label="硬件版本">
                    </el-table-column>
                    <el-table-column
                            prop="manufacturer"
                            align="center"
                            label="制造商">
                    </el-table-column>
                    <el-table-column
                            prop="manufacturer_add"
                            align="center"
                            label="制造商地址">
                    </el-table-column>
                    <el-table-column
                            prop="phone"
                            align="center"
                            label="联系电话">
                    </el-table-column>
                    <el-table-column
                            prop="contact_person"
                            align="center"
                            label="联系人">
                    </el-table-column>

                    <el-table-column
                            prop="tr_user_phone"
                            align="center"
                            label="状态">
                        <template slot-scope="scope">
                            {{$map.menuStatus[scope.row.STATUS]}}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="160px">
                        <template slot-scope="scope">
                            <router-link v-hasPermi="['basic:device:edit']" :to="{path:'/device/device-add',query:{id:scope.row.uuid}}">
                                <el-button size="mini" type="warning" >编辑</el-button>
                            </router-link>
                            <el-popconfirm v-hasPermi="['basic:device:remove']" title="确定禁用此记录吗？" class="cursor" 
                             @confirm="changeStatus(scope.row.id,0)"
                             @onConfirm="changeStatus(scope.row.id,0)"
                             >
                                <a slot="reference" class="red">
                                    <el-button type="danger" size="mini" >删除</el-button>
                                </a>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :page-size="params.limit||10"
                    @current-change = "pageChange"
                    :total="total">
            </el-pagination>
        </div>

        <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
            <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm" >
            </fm-generate-form>
            <div class="center">
                <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
                <el-button @click="cancle" size="small">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getDeviceList,editDevice} from '../../api/device'
    export default {
        data(){
            return{
                list:[],
                params:{page:1,limit:10},
                total:0,
                showDia:false,
                searchForm: this.$getForm('deviceSearch'),
                editData: {},
                remoteFuncs: {

                },
            }
        },
        created(){
            this.getList()
        },
        methods:{
            changeStatus(id,status){
                // editDevice({id:id,status:status}).then(res=>{
                //     this.getList()
                // }).catch(err=>{

                // })
                this.$post('/devicemanage/deletebyid',{id:id}).then(res=>{
                    this.$message.success('删除成功')
                    this.getList()
                }).catch(e=>{})
            },
            cancle(){
                this.showDia=false
                    this.resetSearch()
            },
            getList(){
                getDeviceList(this.params).then(res=>{
                    // console.log(res)
                    this.total = res.data.count
                    this.list = res.data.list
                    
                }).catch(err=>{

                })
            },
            pageChange(val){
                this.params.page = val
                this.getList()
            },
            searchSubmit() {
                this.$refs.searchForm.getData().then(data => {
                    //log(data)
                    this.params = {...this.params,...data}
                this.params.page=1

                    this.getList()
                    this.showDia = false
                }).catch(e => {

                })
            },
            resetSearch() {
                this.$refs.searchForm.reset()
                this.params = {...this.params,...this.$refs.searchForm.models}
                this.getList()
            },
        }
    }
</script>

<style scoped>

</style>
